var _defs, _path, _path2, _rect, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpoStackbuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-fa2825e0-7127-4df6-8845-0d28be2a51de",
    "data-name": "art",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-366adda4-9e97-42fb-9362-cd771794550f",
    x1: 40,
    y1: 60,
    x2: 64.41,
    y2: 84.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-f2d90e3e-2889-469b-8e77-7422cd65b270",
    x1: 38.59,
    y1: 52.59,
    x2: 59,
    y2: 73,
    xlinkHref: "#uuid-366adda4-9e97-42fb-9362-cd771794550f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-81d15159-be7d-4577-b096-c71320e8d847",
    x1: 44,
    y1: 44,
    x2: 61,
    y2: 61,
    xlinkHref: "#uuid-366adda4-9e97-42fb-9362-cd771794550f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-0664d19c-727a-42a6-8faf-f20ae59096d0",
    x1: 44,
    y1: 34,
    x2: 61,
    y2: 51,
    xlinkHref: "#uuid-366adda4-9e97-42fb-9362-cd771794550f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-4fa6f0ab-25f6-4677-90a2-0e3d3d10ad91",
    x1: 44.29,
    y1: 24.88,
    x2: 60.71,
    y2: 41.29,
    xlinkHref: "#uuid-366adda4-9e97-42fb-9362-cd771794550f"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m32.5,67.5h38c1.1,0,2,.9,2,2v6c0,1.1-.9,2-2,2h-36c-1.1,0-2-.9-2-2v-8h0Z",
    fill: "url(#uuid-366adda4-9e97-42fb-9362-cd771794550f)",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m34.5,57.5h30v10h-32v-8c0-1.1.9-2,2-2Z",
    fill: "url(#uuid-f2d90e3e-2889-469b-8e77-7422cd65b270)",
    strokeWidth: 0
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 47.5,
    width: 24,
    height: 10,
    fill: "url(#uuid-81d15159-be7d-4577-b096-c71320e8d847)",
    strokeWidth: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 37.5,
    width: 24,
    height: 10,
    fill: "url(#uuid-0664d19c-727a-42a6-8faf-f20ae59096d0)",
    opacity: 0.5,
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5,27.5h20c1.1,0,2,.9,2,2v8h-24v-8c0-1.1.9-2,2-2Z",
    fill: "url(#uuid-4fa6f0ab-25f6-4677-90a2-0e3d3d10ad91)",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpoStackbuilding);
export default __webpack_public_path__ + "static/media/expo_stackbuilding.48807748d658a34804eb55ce98a746e1.svg";
export { ForwardRef as ReactComponent };